/**
 * @fileoverview DELETE handler for the "/comments/:target/threads/:thread_id/comments/:comment_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { mutationCacheKeys } from "./constants";
import type { AppendAppGroupToUrl, DeleteCommentProps, EmptyResult as DeleteCommentResult } from "./types";

export const deleteComment = reactQueryMutationAdapter(
  mutationCacheKeys,
  (props: AppendAppGroupToUrl<DeleteCommentProps>): Promise<DeleteCommentResult> => {
    return fetch(
      `/comments/${props.target}/threads/${props.threadId}/comments/${props.commentId}?app_group_id=${props.appGroupId}`,
      "DELETE"
    );
  }
);
